import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { fnMoneda } from "../tools";
import { servicios } from "./../properties";
import { goTo } from "./../tools";
import {
  cargarRetenciones,
  descargarRetencion,
  testDos,
  tramitesCarga,
} from "./misTramites.act";
import { ramos } from "./secciones";

const mapState = (state) => {
  return {
    lista_blanca: state.tramites.lista_blanca_state,
    loading: state.global.loading,
    listado: state.tramites.listado,
    retenciones: state.tramites.retenciones,
    historicoPagos: state.tramites.historicoPagos,
  };
};

const urlBASE = servicios.formatos.listaBlanca;

const mapDispatch = (dispatch) => {
  return {
    carga: () => {
      dispatch(tramitesCarga());
    },
    cargarRetenciones: (sAnio) => {
      dispatch(cargarRetenciones(sAnio));
    },
    descargaRetencion: (sIdDocumento, sTipo) => {
      dispatch(descargarRetencion(sIdDocumento, sTipo));
    },
    testUno: () => {
      dispatch(testDos());
    },
    addEvento: (evento) => {
      dispatch({ type: "TRAMITES_SET_EVENT", evento: evento });
    },
  };
};

class MisTramites extends React.Component {
  state = {
    formatos: true,
    ramo: null,
    subRamo: null,
    seccion: [],
    ramos: {
      Todos: "active",
      Vida: "",
      Autos: "",
      Daños: "",
      "Gastos Médicos Mayores": "",
    },
    ramosTitle: "Todos",
    tramites: {
      Reembolso: "",
      "Programación de Cirugía": "",
      "Programación de Tratamiento": "",
      "Pago con Tarjeta": "",
      Otro: "",
      "Beneficios Adicionales": "",
      "Reclamación Pérdidas Orgánicas": "",
      "Reclamación Fallecimiento": "",
      Robo: "",
      "Pérdida Total": "",
      "Pago Siniestros El Palacio de Hierro": "",
    },
    tramitesTitle: "Todos",
    mobileTabs: false,
    mobileRamos: false,
    mobileTramites: false,
    secondMenuTitle: "Formatos",
    showFormatos: true,
    showHistorico: false,
    showRetenciones: false,
    arrowWhite: [
      require("../img/flecha-abajo-blanco.svg"),
      require("../img/flecha-arriba-blanco.svg"),
    ],
    arrowIndexRamos: 0,
    arrowIndexTramites: 0,
    arrowOrange: [
      require("../img/arrow-down.svg"),
      require("../img/arrow-up.svg"),
    ],
    arrowIndexTabs: 0,

    mostrarTodos: true,
    esMismoCorreo: false,

    mostrarBtn: true,
  };

  listaBlancaAjax;

  constructor(props) {
    super(props);
  }

  componentWillMount = () => {
    this.props.carga();
    this.userAction();
  };

  userAction = () => {
    let url = "";
    url = urlBASE;
    $.ajax({
      method: "GET",
      url: url,
      dataType: "json",
      success: (data) => {
        console.log(">>>Respuesta SERV", data);
        this.listaBlancaAjax = data;

        const emailLogueado = localStorage.getItem("correoG");
        const emailLower = emailLogueado.toLowerCase();

        if (data.mostrar === true) {
          this.state.mostrarBtn = true;
        } else {
          this.state.mostrarBtn = false;
          data.listaBlanca.forEach((item) => {
            if (item.toLowerCase() === emailLower) {
              this.state.mostrarBtn = true;
              return;
            }
          });
        }
      },
    });
  };

  selectRamo = (_item) => {
    var temporal = {
      Todos: "",
      Vida: "",
      Autos: "",
      Daños: "",
      "Gastos Médicos Mayores": "",
    };
    var temporalTramites = {
      Reembolso: "",
      "Programación de Cirugía": "",
      "Programación de Tratamiento": "",
      "Pago con Tarjeta": "",
      Otro: "",
      "Beneficios Adicionales": "",
      "Reclamación Pérdidas Orgánicas": "",
      "Reclamación Fallecimiento": "",
      Robo: "",
      "Pérdida Total": "",
      "Pago Siniestros El Palacio de Hierro": "",
    };
    var title = _item.titulo;
    this.props.addEvento(title);
    temporal[_item.titulo] = "active";
    let sRamo = _item.titulo != "Todos" ? _item.titulo : null;
    this.setState({
      ramo: sRamo,
      subRamo: null,
      seccion: _item.secciones,
      ramos: temporal,
      ramosTitle: title,
      tramites: temporalTramites,
    });
    this.showRamos();
  };

  selectSeccion = (_item) => {
    var temporal = {
      Reembolso: "",
      "Programación de Cirugía": "",
      "Programación de Tratamiento": "",
      "Pago con Tarjeta": "",
      Otro: "",
      "Beneficios Adicionales": "",
      "Reclamación Pérdidas Orgánicas": "",
      "Reclamación Fallecimiento": "",
      Robo: "",
      "Pérdida Total": "",
      "Pago Siniestros El Palacio de Hierro": "",
    };
    this.props.addEvento(this.state.ramo + "/" + _item.titulo);
    temporal[_item.titulo] = "active";
    this.setState({
      subRamo: _item.titulo,
      tramitesTitle: _item.titulo,
      tramites: temporal,
    });
    this.showTramites();
  };

  assignClass = (item) => {
    if (this.state.ramos[item.titulo] == "active") {
      return "active";
    }
  };

  assignClassSeccion = (item) => {
    if (this.state.tramites[item.titulo] == "active") {
      return "active";
    }
  };

  selectTab = (sTab) => {
    try {
      event.preventDefault();
    } catch (e) {}
    var title = sTab[0];
    var showFormatos = false;
    var showHistorico = false;
    var showRetenciones = false;

    switch (title) {
      case "Formatos":
        showFormatos = true;
        this.props.addEvento("Formatos");
        break;
      case "Histórico de pagos":
        showHistorico = true;
        this.props.addEvento("HistoricoPagos");
        break;
      case "Mis Retenciones":
        showRetenciones = true;
        this.props.cargarRetenciones("todos");
        this.props.addEvento("MisRetenciones");
        break;
    }

    let state = {
      showFormatos: showFormatos,
      showHistorico: showHistorico,
      showRetenciones: showRetenciones,
      secondMenuTitle: title,
    };

    this.setState(state);
    this.showMobileTabs();
  };

  showMobileTabs = () => {
    var arrowIndexTabs;
    if (this.state.arrowIndexTabs == 1) {
      arrowIndexTabs = 0;
    } else if (this.state.arrowIndexTabs == 0) {
      arrowIndexTabs = 1;
    }

    this.setState({
      mobileTabs: !this.state.mobileTabs,
      arrowIndexTabs: arrowIndexTabs,
    });
  };

  showRamos = () => {
    var arrowIndexRamos;
    if (this.state.arrowIndexRamos == 1) {
      arrowIndexRamos = 0;
    } else if (this.state.arrowIndexRamos == 0) {
      arrowIndexRamos = 1;
    }
    this.setState({
      mobileRamos: !this.state.mobileRamos,
      arrowIndexRamos: arrowIndexRamos,
    });
  };

  showTramites = () => {
    var arrowIndexTramites;
    if (this.state.arrowIndexTramites == 1) {
      arrowIndexTramites = 0;
    } else if (this.state.arrowIndexTramites == 0) {
      arrowIndexTramites = 1;
    }
    this.setState({
      mobileTramites: !this.state.mobileTramites,
      arrowIndexTramites: arrowIndexTramites,
    });
  };

  mostrarMisFormatos = (formato) => {
    let url = "mis-formatos";

    switch (formato) {
      case "bandeja":
        url = "/mis-formatos/bandeja";
        break;
      case "Informe médico/Aviso de accidente y/ o enfermedad":
        url = "/mis-formatos/aviso-accidentes";
        break;
      case "Aviso de accidente y/ o enfermedad":
        url = "/mis-formatos/aviso-accidentes";
        break;
      case "Aviso de accidente y / o enfermedad":
        url = "/mis-formatos/aviso-accidentes";
        break;
      case "Aviso de accidente y/o enfermedad":
        url = "/mis-formatos/aviso-accidentes";
        break;
      case "Ayuda para parto o cesárea":
        url = "/mis-formatos/ayuda-parto-cesarea";
        break;
      case "Formato único de información bancaria":
        url = "/mis-formatos/informacion-bancaria";
        break;
      case "Formato Reembolso de accidente y /o enfermedad":
        url = "/mis-formatos/reembolso-accidentes";
        break;
    }

    goTo(url);
  };

  obtenerRamo = (sRamo) => {
    let ramo = "Autos";

    switch (sRamo) {
      case "A":
        ramo = "Autos";
        break;
      case "G":
        ramo = "Gastos Médicos Mayores";
        break;
      case "V":
        ramo = "Vida";
        break;
      case "D":
        ramo = "Daños";
        break;
    }

    return ramo;
  };

  download = (idDocumentum, sTipo) => {
    this.props.descargaRetencion(idDocumentum, sTipo);
    this.props.addEvento("DescargaRetencion-" + sTipo);
  };

  cargarRetenciones = (event) => {
    let sAnio = event.target.value;

    this.props.cargarRetenciones(sAnio);
  };

  open = (item) => {
    this.props.addEvento(item.ramo + "/" + item.seccion + "/" + item.archivo);
  };

  sendEmail = (item) => {
    window.location = `mailto:?subject=${
      item.archivo || ""
    }&body=Consulta el formato ${
      item.archivo || ""
    } en la siguiente ligas ${encodeURIComponent(item.url)}`;
  };

  render() {
    return (
      <div>
        <div className="second-menu text-center hide-mobile">
          <ul className="clearfix">
            <li>
              <button
                disabled={this.state.showFormatos}
                className={this.state.showFormatos ? "active" : ""}
                onClick={this.selectTab.bind(this, ["Formatos"])}
              >
                Formatos
              </button>
            </li>
            <li>
              <button
                disabled={this.state.showHistorico}
                className={this.state.showHistorico ? "active" : ""}
                onClick={this.selectTab.bind(this, ["Histórico de pagos"])}
              >
                Histórico de pagos{" "}
              </button>
            </li>
            <li>
              <button
                disabled={this.state.showRetenciones}
                className={this.state.showRetenciones ? "active" : ""}
                onClick={this.selectTab.bind(this, ["Mis Retenciones"])}
              >
                Mis Retenciones{" "}
              </button>
            </li>
          </ul>
        </div>
        <div className="second-menu text-center show-mobile">
          <div className="second-menu-select-mobile">
            <p onClick={this.showMobileTabs}>
              {this.state.secondMenuTitle}{" "}
              <img
                src={this.state.arrowOrange[this.state.arrowIndexTabs]}
              ></img>
            </p>
            {this.state.mobileTabs && (
              <ul>
                <li onClick={this.selectTab.bind(this, ["Formatos"])}>
                  <button disabled={this.state.showFormatos}>Formatos</button>
                  <div
                    className={this.state.showFormatos ? "active" : ""}
                  ></div>
                </li>
                <li onClick={this.selectTab.bind(this, ["Histórico de pagos"])}>
                  <button disabled={this.state.showHistorico}>
                    Histórico de pagos
                  </button>
                  <div
                    className={this.state.showHistorico ? "active" : ""}
                  ></div>
                </li>
                <li onClick={this.selectTab.bind(this, ["Mis Retenciones"])}>
                  <button disabled={this.state.showRetenciones}>
                    Mis Retenciones
                  </button>
                  <div
                    className={this.state.showRetenciones ? "active" : ""}
                  ></div>
                </li>
              </ul>
            )}
          </div>
        </div>

        {this.state.showFormatos && (
          <div className="container tramites-main card">
            <div className="section-title-wrap">
              <img src={require("../img/icon-formato.svg")}></img>
              <div className="section-title">
                <h5>Formatos</h5>
                <p>
                  En esta sección puedes llenar, descargar o imprimir los
                  formatos que necesitas para realizar un trámite. Sólo
                  selecciona ramo y trámite.
                </p>
              </div>
            </div>

            {this.state.mostrarBtn && (
              <div className="formatos-container">
                <div
                  className="formatos-add-poliza"
                  onClick={this.mostrarMisFormatos.bind(this, "bandeja")}
                >
                  <img src={require("../img/izquierda.svg")} />
                  <div className="formatos-add-poliza__text">
                    Mis Formatos capturados
                  </div>
                </div>
              </div>
            )}

            <div>
              <div className="submenu-head clearfix mt-30 mb-30">
                <div className="pull-left">
                  <h6>Selecciona un ramo:</h6>
                </div>
              </div>
              <div className="text-center row hide-mobile">
                <table className="tramites-table">
                  <tbody>
                    <tr>
                      {ramos.map((item, i) => (
                        <td key={i} className={this.assignClass(item)}>
                          <a onClick={this.selectRamo.bind(this, item)}>
                            {item.titulo}
                          </a>
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="second menu text-center show-mobile">
                <div
                  onClick={this.showRamos.bind(this)}
                  className="second-menu-select-mobile-orange"
                >
                  <p>
                    {this.state.ramosTitle}{" "}
                    <img
                      src={this.state.arrowWhite[this.state.arrowIndexRamos]}
                    ></img>
                  </p>
                  {this.state.mobileRamos && (
                    <ul>
                      {ramos.map((item, i) => (
                        <li
                          onClick={this.selectRamo.bind(this, item)}
                          key={i}
                          className="col-xs-2"
                        >
                          <a>{item.titulo}</a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {this.state.seccion.length > 0 && (
              <div>
                <div className="submenu-head clearfix mt-30 mb-30">
                  <div className="pull-left">
                    <h6>Selecciona un trámite:</h6>
                  </div>
                </div>
                <div className="text-center row hide-mobile">
                  <table className="tramites-table">
                    <tbody>
                      <tr>
                        {this.state.seccion.map((item, i) => (
                          <td key={i}>
                            <a
                              className={this.assignClassSeccion(item)}
                              onClick={this.selectSeccion.bind(this, item)}
                            >
                              {item.titulo}
                            </a>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="show-mobile second-menu-select-mobile-orange">
                  <p onClick={this.showTramites.bind(this)}>
                    {this.state.tramitesTitle}{" "}
                    <img
                      src={this.state.arrowWhite[this.state.arrowIndexTramites]}
                    ></img>
                  </p>
                  {this.state.mobileTramites && (
                    <ul>
                      {this.state.seccion.map((item, i) => (
                        <li
                          onClick={this.selectSeccion.bind(this, item)}
                          key={i}
                          className="col-xs-2"
                        >
                          <a>{item.titulo}</a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            )}
            <div className="cards-wrap mt-25">
              <div className="row">
                <div className="col-12">
                  <div className="ramos-row-wrapper">
                    {this.props.listado.map((item, i) => (
                      <div
                        className="ramos-row"
                        key={i}
                        style={{
                          display: this.state.ramo
                            ? this.state.ramo == item.ramo
                              ? this.state.subRamo
                                ? this.state.subRamo == item.seccion
                                  ? "block"
                                  : "none"
                                : "block"
                              : "none"
                            : "block",
                        }}
                      >
                        <img src={require("../img/pdf_icon.svg")}></img>
                        <span className="texto-18">{item.archivo}</span>
                        <div className="tramites-download mt-15">
                          <a
                            onClick={this.open.bind(this, item)}
                            href={item.url}
                            target="_blank"
                            download
                          >
                            <img src={require("../img/icon-dowload.svg")}></img>
                          </a>
                        </div>
                        {this.state.mostrarBtn && (
                          <React.Fragment>
                            {item.ramo === this.state.ramo && (
                              <span style={{ display: "inline" }}>
                                {(item.seccion === "Reembolso" ||
                                  item.seccion ===
                                    "Ayuda para Parto o Cesárea") && (
                                  <div
                                    className="tramites-download mt-15"
                                    id="doc-reeembolso"
                                  >
                                    <a
                                      onClick={this.sendEmail.bind(this, item)}
                                      className="formatos-ir-formato"
                                    >
                                      <img
                                        src={require("../img/send_24px.svg")}
                                      ></img>
                                    </a>
                                  </div>
                                )}

                                {(item.archivo ===
                                  "Informe médico/Aviso de accidente y/ o enfermedad" ||
                                  item.archivo ===
                                    "Aviso de accidente y/ o enfermedad" ||
                                  item.archivo ===
                                    "Aviso de accidente y / o enfermedad" ||
                                  item.archivo ===
                                    "Aviso de accidente y/o enfermedad" ||
                                  item.archivo ===
                                    "Formato Reembolso de accidente y /o enfermedad" ||
                                  item.archivo ===
                                    "Formato único de información bancaria" ||
                                  item.archivo ===
                                    "Ayuda para parto o cesárea") &&
                                  (item.seccion === "Reembolso" ||
                                    item.seccion ===
                                      "Ayuda para Parto o Cesárea") && (
                                    <div className="tramites-download mt-15">
                                      <div
                                        onClick={this.mostrarMisFormatos.bind(
                                          this,
                                          item.archivo
                                        )}
                                        className="formatos-ir-formato"
                                      >
                                        <img
                                          src={require("../img/phonelink_24px.svg")}
                                        ></img>
                                        <p>Captura digital</p>
                                      </div>
                                    </div>
                                  )}
                              </span>
                            )}
                          </React.Fragment>
                        )}

                        {!this.state.ramo && (
                          <div className="tramites-ramo">
                            <h6>{item.ramo}</h6>
                            <p className="blue-text">{item.seccion}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showHistorico && (
          <div className="container tramites-main card">
            <div className="row">
              <div className="col-xs-12 col-md-12">
                <div className="section-title-wrap">
                  <img src={require("../img/icon-hist-rico.svg")} />
                  <div className="section-title">
                    <h5>Histórico Pagos</h5>
                    <p>
                      En esta sección puedes consultar el Historial de tus
                      últimos 10 pagos realizados a través del Portal Soy
                      Cliente y/o Aplicación Soy Cliente GNP, conforme a la
                      fecha de operación.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <table className="table table-striped table-center mt-34 tabla-historico">
                      <thead>
                        <tr>
                          <th>Ramo</th>
                          <th>No. Póliza</th>
                          <th className="hide-mobile">
                            Fecha y hora de la operación
                          </th>
                          <th className="hide-mobile">
                            Descripción de la operación
                          </th>
                          <th>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.historicoPagos.map((item, i) => (
                          <tr key={i}>
                            <td>
                              {this.obtenerRamo(item.result.lineaNegocio)}
                            </td>
                            <td>{item.result.numPoliza}</td>
                            <td className="hide-mobile">
                              {moment(item.timestamp).format(
                                "DD/MM/YYYY HH:mm:ss a"
                              )}
                            </td>
                            <td className="hide-mobile">Pago de Prima</td>
                            <td>
                              ${" "}
                              {fnMoneda(
                                item.result.cobranzaliquidacionResponse.importe
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showRetenciones && (
          <div className="container tramites-main card">
            <div className="row">
              <div className="col-xs-12 col-md-12">
                <div className="section-title-wrap">
                  <img src={require("../img/icon-retenciones.svg")} />
                  <div className="section-title">
                    <h5>Mis Retenciones</h5>
                    <p>
                      En esta seccion puedes consultar tus retenciones por año.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="submenu-head clearfix mt-30">
                <div className="input-wrap">
                  <h6>Selecciona un año:</h6>
                  <span className="clearfix" style={{ width: 250 }}>
                    <select onChange={this.cargarRetenciones}>
                      <option value="todos">Todos</option>
                      <option value="2018">2018</option>
                      <option value="2017">2017</option>
                      <option value="2016">2016</option>
                      <option value="2015">2015</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
            <div className="cards-wrap">
              <div className="row">
                <div className="col-12">
                  <div className="ramos-row-wrapper">
                    {this.props.retenciones.map((item, i) => (
                      <div key={i}>
                        <div className="ramos-row">
                          <img src={require("../img/pdf_icon.svg")}></img>
                          <span className="texto-18">
                            {item.tsExpedicionCfd}
                          </span>
                          <div className="tramites-download mt-15">
                            <a
                              onClick={this.download.bind(
                                this,
                                item.idDocumentum.idPdf,
                                "pdf"
                              )}
                            >
                              <img src={require("../img/icon-dowload.svg")} />
                            </a>
                          </div>
                        </div>
                        <div className="ramos-row">
                          <img src={require("../img/xml_icon.svg")}></img>
                          <span className="texto-18">
                            {item.tsExpedicionCfd}
                          </span>
                          <div className="tramites-download mt-15">
                            <a
                              onClick={this.download.bind(
                                this,
                                item.idDocumentum.idXml,
                                "xml"
                              )}
                            >
                              <img src={require("../img/icon-dowload.svg")} />
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(MisTramites);



// WEBPACK FOOTER //
// ./src/mis-tramites/misTramites.cmpt.js